import type { StyleRule } from '@archipro-design/aria';

export const BaseStyle: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colorScheme.default?.background,
});
